import { Component, inject } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { SessionService } from '../../services/session.service';

@Component({
  template: ''
})
export abstract class BaseComponent {
  public navigationService = inject(NavigationService);
  public sessionService = inject(SessionService);

  public toUrl(url: string) {
    this.navigationService.toUrl(url);
  }
}
